import { Row, Col, Form, Select, InputNumber } from "antd"
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import UserRoleDropdown from "../../../UserRoleDropdown";


const PublicationNotificationRule = ({ notification, form, notificationType, definedWidgets }) => {
    const { t } = useTranslation();
    const [dateFields, setDateFields] = useState([])
    const [pickerFields, setPickerFields] = useState([])
    const formValues = Form.useWatch([], form);


    useEffect(() => {
        if (definedWidgets && definedWidgets.length > 0) {
            const dateFieldList = definedWidgets.filter(widget => widget.formType === 'dateForm').map(widget => ({ label: widget.label, value: widget.id }));
            const pickerFieldList = definedWidgets.filter(widget => widget.formType === 'userForm').map(widget => ({ label: widget.label, value: widget.id }));
           dateFieldList.unshift({ label: t("Step Due Date"), value: "dueDate" })
           dateFieldList.unshift({ label: t("Creation Date"), value: "createdOn" })
            setDateFields(dateFieldList);
            setPickerFields(pickerFieldList);
        }
    }, [definedWidgets])

    useEffect(() => {
        if (notification.notificationId) {
            form.setFieldsValue({ ...notification })
        } else {
            // Set default values for new notifications
            const currentValues = form.getFieldsValue();
            form.setFieldsValue({
                period: currentValues.period || 'day',
                occurrence: currentValues.occurrence || 'before',
                count: currentValues.count || 1,
                frequency: currentValues.frequency || 1,
                notificationCount: currentValues.notificationCount || 1,
            });
        }
    }, [notification])

    return (
        <div>
            <Row gutter={8}>
                <Col span={24}>
                    <Form.Item label={t("The notification will be triggered on:")} required>
                        <Row gutter={8}>
                            <Col span={6}>
                                <Form.Item name="count" noStyle>
                                    <InputNumber
                                        placeholder={t("Number")}
                                        min={1}
                                        parser={(value) => value.replace(/[^0-9]/g, '')}
                                        style={{ width: '100%' }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item name="period" noStyle rules={[{ required: true, message: t('Period is required') }]}>
                                    <Select style={{ width: '100%' }}>
                                        <Select.Option value="day">{t("Days")}</Select.Option>
                                        <Select.Option value="week">{t("Weeks")}</Select.Option>
                                        <Select.Option value="month">{t("Months")}</Select.Option>
                                        <Select.Option value="quarter">{t("Quarters")}</Select.Option>
                                        <Select.Option value="year">{t("Years")}</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item name="occurrence" style={{ width: '100%' }} rules={[{ required: true, message: t('Occurrence is required') }]}>
                                    <Select
                                        options={[
                                            {
                                                value: "before",
                                                label: t("Before"),
                                            },
                                            {
                                                value: "after",
                                                label: t("After"),
                                            }
                                        ]}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item name="triggerDate" style={{ width: '100%' }} rules={[{ required: true, message: t('Trigger date is required') }]}>
                                    <Select options={dateFields} placeholder={t("Select trigger date field")} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form.Item>

                </Col>
            </Row>
            <Row gutter={8}>
                <Col span={12}>
                    <div className="mb-[5px]">{t("And will be resend on every (day):")}</div>
                    <Form.Item name="frequency" style={{ width: '100%' }}>
                        <InputNumber
                            placeholder={t("Number")}
                            min={1}
                            parser={(value) => value.replace(/[^0-9]/g, '')}
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <div className="mb-[5px]">{t("Occurrences (Total Number of notifications to be sent):")}</div>
                    <Form.Item name="notificationCount" style={{ width: '100%' }}>
                        <InputNumber
                            placeholder={t("Number")}
                            min={1}
                            parser={(value) => value.replace(/[^0-9]/g, '')}
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                </Col>


            </Row>

            <Form.Item label={t("Recipients")} name="recipients" style={{ width: '100%' }} rules={[{ required: true, message: t('Recipients are required') }]}>
                {/* <Select mode="multiple" options={pickerFields} /> */}
                {/* <UserRoleDropdown mode="multiple" options={pickerFields} /> */}
                <UserRoleDropdown
                    placeholder={t("Select Recipients")}
                    selectedOptions={formValues?.["recipients"] || { user: [], group: [], role: [], userPicker: [] }}
                    getSpaceUsers={true}
                    tabsRequired={["user", "group", "role", "userPicker"]}
                    onSelect={(value) => {
                        form.setFieldValue("recipients", value)
                        if (form.validateFields) {
                            form.validateFields(["recipients"])
                        }

                    }}
                    mode="MULTIPLE"
                />
            </Form.Item>

        </div>
    )
}

export default PublicationNotificationRule